import { CometChatEmojiKeyboard, CometChatIconButton, CometChatButton, CometChatDate, CometChatLabel, CometChatLoader, CometChatAvatar, CometChatReceipt } from "@cometchat/uikit-elements";
import { CometChatReactions } from "@cometchat/uikit-shared";
import { createComponent } from "@lit-labs/react";
import React from "react";
/**
 * Converts Lit web components into React components using the createComponent function from lit labs. This conversion allows these components to be seamlessly integrated and used within a React application while preserving their original functionalities and event handling capabilities.
 **/

/**
 * Converts CometChatReactions Lit web component to a React component using createComponent from lit labs. This can be used to show a list of reactions for a particular message. It can be customized using the style class of this component.For more details, go to [CometChatReactions](https://www.cometchat.com/docs-beta/ui-kit/react/reaction)
 *
 */
export const CometChatReactionsView = createComponent({
    tagName: "cometchat-reactions",
    elementClass: CometChatReactions,
    react: React,
});

/**
 * Converts CometChatEmojiKeyboard Lit web component to a React component using createComponent from lit labs. This can be used to show a list of emojis, which returns a particular emoji on click. It can be customized using the style class of this component.For more details, go to [CometChatEmojiKeyboard](https://www.cometchat.com/docs-beta/ui-kit/react/emoji-keyboard)
 *
 */
export const CometChatEmojiKeyboardView = createComponent({
    tagName: "cometchat-emoji-keyboard",
    elementClass: CometChatEmojiKeyboard,
    events: {
        onEmojiClick: "cc-emoji-clicked",
    },
    react: React,
});

/**
 * Converts CometChatIconButton Lit web component to a React component using createComponent from lit labs. This can be used to display a button which has an icon, a button, or both. It can be customized using the style class of this component.For more details, go to [CometChatIconButton](https://www.cometchat.com/docs-beta/ui-kit/react/icon-button)
 */
export const CometChatIconButtonView = createComponent({
    tagName: "cometchat-icon-button",
    elementClass: CometChatIconButton,
    react: React,
    events: {
        buttonClick: "cc-button-clicked",
    },
});

/**
 * Converts CometChatButton Lit web component to a React component using createComponent from lit labs. It can be used to display a button with customizable text. It can be customized using the style class of this component.
 */
export const CometChatButtonView = createComponent({
    tagName: "cometchat-button",
    elementClass: CometChatButton,
    react: React,
    events: {
        buttonClick: "cc-button-clicked",
    },
});

/**
 * Converts CometChatDate Lit web component to a React component using createComponent from lit labs. It can be used to display a date in different time formats by providing the enum and timestamp. It can be customized using the style class of this component.For more details, go to [CometChatDate](https://www.cometchat.com/docs-beta/ui-kit/react/date)
 */
export const CometChatDateView = createComponent({
    tagName: "cometchat-date",
    elementClass: CometChatDate,
    react: React,
});

/**
 * Converts CometChatLabel Lit web component to a React component using createComponent from lit labs. It can be used to display normal text or a title with customizable text. It can be customized using the style class of this component.For more details, go to [CometChatLabel](https://www.cometchat.com/docs-beta/ui-kit/react/label)
 */
export const CometChatLabelView = createComponent({
    tagName: "cometchat-label",
    elementClass: CometChatLabel,
    react: React,
});

/**
 * Converts CometChatLoader Lit web component to a React component using createComponent from lit labs. It can be used to display a loading icon which is customizable. By default, it has a loading icon inside the component. It can be customized using the style class of this component.For more details, go to [CometChatLoader](https://www.cometchat.com/docs-beta/ui-kit/react/loader)
 */

export const CometChatLoaderView = createComponent({
    tagName: "cometchat-loader",
    elementClass: CometChatLoader,
    react: React,
});

/**
 * Converts CometChatAvatar Lit web component to a React component using createComponent from lit labs. It can be used to display a user/group image with a fallback name if the URL is not present. It can be customized using the style class of this component. For more details, go to [CometChatAvatar](https://www.cometchat.com/docs-beta/ui-kit/react/avatar)
 */
export const CometChatAvatarView = createComponent({
    tagName: "cometchat-avatar",
    elementClass: CometChatAvatar,
    react: React,
});

/**
 * Converts CometChatReceipt Lit web component to a React component using createComponent from lit labs. It can be used to display various types of receipt statuses for a message (like sent, delivered, etc.) which can be customized by sending the enum for which state to be shown. It can be customized using the style class of this component.For more details, go to [CometChatReceipt](https://www.cometchat.com/docs-beta/ui-kit/react/receipt)
 */
export const CometChatReceiptView = createComponent({
    tagName: "cometchat-receipt",
    elementClass: CometChatReceipt,
    react: React,
});
